/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { billingControllerCancelSubscription } from '../fn/billing/billing-controller-cancel-subscription';
import { BillingControllerCancelSubscription$Params } from '../fn/billing/billing-controller-cancel-subscription';
import { billingControllerCreateCheckoutSession } from '../fn/billing/billing-controller-create-checkout-session';
import { BillingControllerCreateCheckoutSession$Params } from '../fn/billing/billing-controller-create-checkout-session';
import { billingControllerGetBillingStatus } from '../fn/billing/billing-controller-get-billing-status';
import { BillingControllerGetBillingStatus$Params } from '../fn/billing/billing-controller-get-billing-status';
import { billingControllerHandleStripeWebhook } from '../fn/billing/billing-controller-handle-stripe-webhook';
import { BillingControllerHandleStripeWebhook$Params } from '../fn/billing/billing-controller-handle-stripe-webhook';
import { billingControllerUpdatePaymentMethod } from '../fn/billing/billing-controller-update-payment-method';
import { BillingControllerUpdatePaymentMethod$Params } from '../fn/billing/billing-controller-update-payment-method';
import { BillingStatusDto } from '../models/billing-status-dto';
import { CheckoutSessionDto } from '../models/checkout-session-dto';

@Injectable({ providedIn: 'root' })
export class BillingService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `billingControllerCreateCheckoutSession()` */
  static readonly BillingControllerCreateCheckoutSessionPath = '/billing/create-checkout-session';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `billingControllerCreateCheckoutSession()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  billingControllerCreateCheckoutSession$Response(params: BillingControllerCreateCheckoutSession$Params, context?: HttpContext): Observable<StrictHttpResponse<CheckoutSessionDto>> {
    return billingControllerCreateCheckoutSession(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `billingControllerCreateCheckoutSession$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  billingControllerCreateCheckoutSession(params: BillingControllerCreateCheckoutSession$Params, context?: HttpContext): Observable<CheckoutSessionDto> {
    return this.billingControllerCreateCheckoutSession$Response(params, context).pipe(
      map((r: StrictHttpResponse<CheckoutSessionDto>): CheckoutSessionDto => r.body)
    );
  }

  /** Path part for operation `billingControllerGetBillingStatus()` */
  static readonly BillingControllerGetBillingStatusPath = '/billing/status';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `billingControllerGetBillingStatus()` instead.
   *
   * This method doesn't expect any request body.
   */
  billingControllerGetBillingStatus$Response(params?: BillingControllerGetBillingStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<BillingStatusDto>> {
    return billingControllerGetBillingStatus(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `billingControllerGetBillingStatus$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  billingControllerGetBillingStatus(params?: BillingControllerGetBillingStatus$Params, context?: HttpContext): Observable<BillingStatusDto> {
    return this.billingControllerGetBillingStatus$Response(params, context).pipe(
      map((r: StrictHttpResponse<BillingStatusDto>): BillingStatusDto => r.body)
    );
  }

  /** Path part for operation `billingControllerCancelSubscription()` */
  static readonly BillingControllerCancelSubscriptionPath = '/billing/cancel-subscription';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `billingControllerCancelSubscription()` instead.
   *
   * This method doesn't expect any request body.
   */
  billingControllerCancelSubscription$Response(params?: BillingControllerCancelSubscription$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return billingControllerCancelSubscription(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `billingControllerCancelSubscription$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  billingControllerCancelSubscription(params?: BillingControllerCancelSubscription$Params, context?: HttpContext): Observable<void> {
    return this.billingControllerCancelSubscription$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `billingControllerUpdatePaymentMethod()` */
  static readonly BillingControllerUpdatePaymentMethodPath = '/billing/update-payment-method';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `billingControllerUpdatePaymentMethod()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  billingControllerUpdatePaymentMethod$Response(params: BillingControllerUpdatePaymentMethod$Params, context?: HttpContext): Observable<StrictHttpResponse<CheckoutSessionDto>> {
    return billingControllerUpdatePaymentMethod(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `billingControllerUpdatePaymentMethod$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  billingControllerUpdatePaymentMethod(params: BillingControllerUpdatePaymentMethod$Params, context?: HttpContext): Observable<CheckoutSessionDto> {
    return this.billingControllerUpdatePaymentMethod$Response(params, context).pipe(
      map((r: StrictHttpResponse<CheckoutSessionDto>): CheckoutSessionDto => r.body)
    );
  }

  /** Path part for operation `billingControllerHandleStripeWebhook()` */
  static readonly BillingControllerHandleStripeWebhookPath = '/billing/webhook';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `billingControllerHandleStripeWebhook()` instead.
   *
   * This method doesn't expect any request body.
   */
  billingControllerHandleStripeWebhook$Response(params?: BillingControllerHandleStripeWebhook$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return billingControllerHandleStripeWebhook(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `billingControllerHandleStripeWebhook$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  billingControllerHandleStripeWebhook(params?: BillingControllerHandleStripeWebhook$Params, context?: HttpContext): Observable<void> {
    return this.billingControllerHandleStripeWebhook$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
